var React = require('react');

function Calendar (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M18.333 20H1.667A1.669 1.669 0 0 1 0 18.333v-15c0-.919.748-1.666 1.667-1.666h4.166V.833a.833.833 0 1 1 1.667 0v.834h5V.833a.833.833 0 1 1 1.667 0v.834h4.166c.92 0 1.667.747 1.667 1.666v15c0 .92-.747 1.667-1.667 1.667zM14.167 3.333v.834a.833.833 0 1 1-1.667 0v-.834h-5v.834a.833.833 0 1 1-1.667 0v-.834H1.667v15H18.33l.002-15h-4.166zM15.833 15h-1.666a.833.833 0 0 1-.834-.833V12.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm0-5h-1.666a.833.833 0 0 1-.834-.833V7.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm-5 5H9.167a.833.833 0 0 1-.834-.833V12.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm0-5H9.167a.833.833 0 0 1-.834-.833V7.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm-5 5H4.167a.833.833 0 0 1-.834-.833V12.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833zm0-5H4.167a.833.833 0 0 1-.834-.833V7.5c0-.46.373-.833.834-.833h1.666c.461 0 .834.373.834.833v1.667c0 .46-.373.833-.834.833z"}));
}

Calendar.displayName = "Calendar";

Calendar.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Calendar;

Calendar.default = Calendar;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/calendar.svg
// module id = 1261
// module chunks = 0